import { render, staticRenderFns } from "./jumlahBaptis.vue?vue&type=template&id=6d32811a&scoped=true&"
import script from "./jumlahBaptis.vue?vue&type=script&lang=js&"
export * from "./jumlahBaptis.vue?vue&type=script&lang=js&"
import style0 from "./jumlahBaptis.vue?vue&type=style&index=0&id=6d32811a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d32811a",
  null
  
)

export default component.exports